var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{staticClass:"sync-progress",attrs:{"color":"#0000f8","size":_vm.$attrs.size}},[_vm._v(" mdi-sync ")])
}
var staticRenderFns = []

export { render, staticRenderFns }